// Definimos a versão da api que está sendo utilizada em todas as requisições
import { version } from './config';

const requesting = false;

export default {
  all(payload  = {}) {
    let page = payload.page || 1;
    let endPoint = `/api/${version}/monitoramentos?limit=50&page=${page}`;
    if (payload.pastaId) {
      endPoint = `${endPoint}&pasta_id=${payload.pastaId}`
    }
    return axios.get(endPoint);
  },
  find(id) {
    return axios.get(`/api/${version}/monitoramentos/${id}`);
  },
  destroy(id) {
    return axiosWithoutLoading.delete(`/api/${version}/monitoramentos/${id}`);
  },
  store(payload) {
    if (payload.processo) {
      return axios.post('/api/interno/processos', payload.form);
    }
    return axios.post(`/api/${version}/monitoramentos`, payload.form);
  },
  edit(payload, cb) {
    return axios.put(`/api/${version}/monitoramentos/${payload.id}`, payload)
        .then(({ data }) => cb(data));
  },
  mover(monitoramentoId, pastaId) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/mover`, {
      monitoramentos: [monitoramentoId],
      pastaId,
    });
  },
  removerDaPasta(monitoramentoId) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/mover`, {
      monitoramentos: [monitoramentoId],
      pastaId: null,
    });
  },
  criarPastaMonitoramento(pasta, cb) {
    return axios.post(`/api/${version}/pastas`, {
      pasta,
    })
      .then(({ data }) => {
        cb(data);
        return data;
      });
  },
  criarPastaMoverMonitoramento(payload) {
    return axios.post(`/api/${version}/pastas`, payload);
  },
  editarPastaMonitoramento(payload) {
    return axios.put(`/api/${version}/pastas/${payload.pastaId}`, {nome: payload.pastaNome});
  },
  excluirPastaMonitoramento({ pastaId, excluirMonitoramentos }) {
    const excluir = excluirMonitoramentos ? 1 : 0;
    return axios.delete(`/api/${version}/pastas/${pastaId}?excluir_monitoramentos=${excluir}`);
  },
  getAparicao(payload) {
    let endPoint = `/api/${version}/monitoramentos/${payload.monitoramentoId}/aparicoes/${payload.id}`;

    return axios.get(endPoint, {
      params: {
        token_unico: payload.tokenUnico
      }
    });
  },
  getProcesso(payload) {
    const endPoint = `/api/${version}/monitoramentos/${payload.id}/processo`;
    return axios.get(endPoint);
  },
  getQuantidadeAparicoesNaoVisualizadas(payload) {
    const endPoint = `/api/${version}/monitoramentos/${payload.id}/processo/quantidade-aparicoes-nao-visualizadas`;
    return axiosWithoutLoading.get(endPoint);
  },
  getMovimentacoesTribunal(payload) {
    const page = payload.page || 1;
    return axios.get(`/api/${version}/processo-tribunal/${payload.numero}/instancia/${payload.instanciaId}/movimentacoes?page=${page}`);
  },
  getMovimentacoesDiario(payload) {
    const page = payload.page || 1;
    return axios.get(`/api/${version}/processos/${payload.processoId}/movimentacoes?page=${page}`);
  },
  getAparicoesMovimentacoesProcesso(payload) {
    const page = payload.page || 1;

    return axios.get(`/api/${version}/monitoramentos/${payload.monitoramentoId}/aparicoes/movimentacoes-processo`, {
      params: {
        token_unico: payload.tokenUnico,
        page: page
      }
    });
  },
  getAparicoesMovimentacoesDiario(payload) {
    const page = payload.page || 1;

    return axios.get(`/api/${version}/monitoramentos/${payload.monitoramentoId}/aparicoes/diario/movimentacoes-processo`, {
      params: {
        token_unico: payload.tokenUnico,
        page: page
      }
    });
  },
  getAparicoesMovimentacoesTribunal(payload) {
    const page = payload.page || 1;

    return axios.get(`/api/${version}/monitoramentos/${payload.monitoramentoId}/aparicoes/instancia/${payload.instanciaId}/movimentacoes`, {
      params: {
        token_unico: payload.tokenUnico,
        page: page
      }
    });
  },
  getAparicoes({ id, page }, cb) {
    let endPoint = `/api/${version}/monitoramentos/${id}/aparicoes`;
    if (page) {
      endPoint += `?page=${page}`;
    }
    return axios.get(endPoint);
  },
  getAllAparicoes(page, cb) {
    let endPoint = `/api/${version}/monitoramentos/aparicoes`;
    if (page) {
      endPoint += `?page=${page}`;
    }
    return axios.get(endPoint)
          .then(({ data }) => cb(data));
  },
  getAparicoesFavoritas(page, cb) {
    let endPoint = `/api/${version}/monitoramentos/aparicoes/favoritos`;
    if (page) {
      endPoint += `?page=${page}`;
    }
    return axios.get(endPoint)
          .then(({ data }) => cb(data));
  },
  getPastas(cb) {
    return axios.get(`/api/${version}/pastas`)
        .then(({ data }) => cb(data));
  },
  favoritarAparicoes(aparicaoId) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/aparicoes/favoritar`, {
      itens: [aparicaoId],
    });
  },
  desfavoritarAparicoes(aparicaoId) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/aparicoes/desfavoritar`, {
      itens: [aparicaoId],
    });
  },
  visualizarAparicoes(aparicaoId) {
    return axiosWithoutLoading.post('/ajax/monitoramentos/notificacoes/visualizar', {
      itens: [aparicaoId],
    });
  },
  visualizarAparicao(payload) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/${payload.monitoramentoId}/aparicoes/${payload.id}/visualizar`);
  },
  marcarNaoVisualizadaAparicoes(aparicaoId) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/aparicoes/marcar-nao-visualizada`, {
      itens: [aparicaoId],
    });
  },
  excluirAparicoes(aparicoes) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/aparicoes/excluir`, {
      aparicoes_id: aparicoes,
    });
  },
  getOrigens() {
    return axios.get(`/api/${version}/origens`);
  },
  getCobertura() {
    return axios.get(`/api/${version}/ajuda/cobertura`);
  },
  marcarAparicoesTribunalInstanciaVisualizadas(payload) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/${payload.monitoramentoId}/tribunal/instancia/${payload.instanciaId}/ler-aparicoes`);
  },
  marcarAparicoesTribunalVisualizadas(payload) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/${payload.monitoramentoId}/tribunal/ler-aparicoes`);
  },
  marcarAparicoesDiarioVisualizadas(payload) {
    return axiosWithoutLoading.post(`/api/${version}/monitoramentos/${payload.monitoramentoId}/diario/ler-aparicoes`);
  },
  getProcessosDoTermo(payload) {
    return axios.post(`/api/${version}/processos/envolvido`, {
      termo: payload.termo,
    });
  },
  alterarStatusSugestao(payload) {
    return axiosWithoutLoading.put(`/api/${version}/monitoramentos/${payload.monitoramentoId}/sugestao/${payload.sugestaoId}`, payload);
  },
  getReferenciasProcesso(payload) {
    const page = payload.page || 1;
    return axios.get(`/api/${version}/monitoramentos/${payload.monitoramentoId}/aparicoes/citacoes-processo?page=${page}`);
  },
  pesquisarMonitoramentos(payload) {
    return axios.get(`/api/${version}/monitoramentos/busca?query=${payload.query}`);
  },
  getDiario(payload) {
    const page = payload.page || 1;
    const endPoint = `/api/${version}/diarios/${payload.id}?page=${page}`;
    return axios.get(endPoint);
  },
  consultarStatusAtivacaoProcessoTribunal(payload) {
    return axiosWithoutLoading.get(`/api/interno/processos/${payload.id}/status`);
  },
  getSugestoesDoMonitoramento(payload) {
    const page = payload.page || 1;
    return axios.get(`/api/${version}/monitoramentos/${payload.monitoramentoId}/sugestoes?page=${page}`);
  },
};
